"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("./ColumnConfig"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
class ButtonsColumnConfig extends ColumnConfig_1.default {
    constructor(args) {
        super(args);
        this.renderer = {
            render(ctx, obj) {
                const div = new fmko_ts_widgets_1.Div();
                div.element.classList.add("button-td-button-container");
                for (const image of obj.buttons) {
                    div.add(image);
                }
                ctx.setWidget(div);
            },
            canRender(_o) {
                return true;
            }
        };
    }
    getData(data) {
        return { data: data, buttons: this.mapDataToTD(data) };
    }
}
exports.default = ButtonsColumnConfig;
//# sourceMappingURL=ButtonsColumnConfig.js.map